import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "pencil",
	"data-name": "pencil",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M21.51,7.25,8,20.78,2.5,21.5,3.22,16,16.75,2.49a3.34,3.34,0,0,1,2.38-1h0A3.37,3.37,0,0,1,22.5,4.87h0A3.34,3.34,0,0,1,21.51,7.25Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 14.88,
			y1: 4.36,
			x2: 19.64,
			y2: 9.12
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M8,20.77H8L2.5,21.5,3.22,16h0a6.59,6.59,0,0,1,3,1.74A6.59,6.59,0,0,1,8,20.77Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.26,
			y1: 6.74,
			x2: 6.26,
			y2: 17.74
		})
	]
});
const ForwardRef = forwardRef(SvgPencil);
export default ForwardRef;
